import {
  CHART_STORE_UPDATE,
  CHART_STORE_REMOVE,
  CHART_STORE_FORCE_DATA,
} from '../../constants/ActionTypes';
import { getChartStoreData } from './getters';

export const updateChart =
  (id, data = {}) =>
  (dispatch) => {
    if (!id) {
      console.error('updateChart Id not found');

      return Promise.resolve();
    }

    setTimeout(() => {
      dispatch({
        type: CHART_STORE_UPDATE,
        data,
        id,
      });
    }, 10);

    return Promise.resolve();
  };

export const clearSelectedHoverItem = (id) => (dispatch, getState) => {
  const chartStoreData = getChartStoreData(getState());
  const targetData = chartStoreData[id] || {};
  let { selectedHoverItem = {} } = targetData;

  targetData.selectedHoverItem = {
    ...selectedHoverItem,
    show: false,
  };

  dispatch(updateChart(id, targetData));

  return Promise.resolve();
};

export const updateSelectedHoverItem =
  (id, data = {}) =>
  (dispatch, getState) => {
    const chartStoreData = getChartStoreData(getState());
    const targetData = chartStoreData[id] || {};
    let { selectedHoverItem = {} } = targetData;

    targetData.selectedHoverItem = {
      ...selectedHoverItem,
      ...data,
    };

    dispatch(updateChart(id, targetData));

    return Promise.resolve();
  };

export const updateSelectedClickItem =
  (id, data = {}) =>
  (dispatch, getState) => {
    const chartStoreData = getChartStoreData(getState());
    const targetData = chartStoreData[id] || {};
    let { selectedClickItem = {} } = targetData;

    targetData.selectedClickItem = {
      ...selectedClickItem,
      ...data,
    };

    dispatch(updateChart(id, targetData));

    return Promise.resolve();
  };

export const clearSelectedClickItem = (id) => (dispatch, getState) => {
  const chartStoreData = getChartStoreData(getState());
  const targetData = chartStoreData[id] || {};

  targetData.selectedClickItem = {};

  dispatch(updateChart(id, targetData));

  return Promise.resolve();
};

export const clearAllChartPoints = () => (dispatch, getState) => {
  const chartStoreData = getChartStoreData(getState());
  const allData = chartStoreData || {};

  Object.entries(allData).forEach(([key]) => {
    allData[key] = {};
  });

  dispatch({
    type: CHART_STORE_FORCE_DATA,
    data: allData,
  });

  return Promise.resolve();
};

export const removeChart = (id) => (dispatch) => {
  dispatch({
    type: CHART_STORE_REMOVE,
    id,
  });

  return Promise.resolve();
};
